import script from "./seller-general-account-setup.vue?vue&type=script&setup=true&lang=js"
export * from "./seller-general-account-setup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__